import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './joinTheMovementSection.module.css';


function JTMSItem(props) {
    return (
        <div className={styles.listingItem}>
            {
                (props.item.image) ?
                <img src={props.item.image.image.asset.url} alt="" />
                : ``
            }
        </div>
    );
}
  
export default JTMSItem;